import {DefaultFieldWindow} from "./DefaultFieldWindow";
import {Form as FormEntity} from "../Form";
import {containerfield, Fieldset, numberfield} from "@intermesh/goui";

import {t} from "../Translate";

export class NumberFieldWindow extends DefaultFieldWindow {
	constructor(formEntity:FormEntity, type:string) {
		super(formEntity, type);

		const fs = this.generalTab.items.get(0) as Fieldset

		fs.items.add(
			containerfield({name: "options"},
				numberfield({
					decimals: 0,
					label: t("Decimals"),
					name: "decimals"
				})
			)
		)
	}
}